var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2L7.70711 1.29289L7 0.585786L6.29289 1.29289L7 2ZM13.7071 7.29289L7.70711 1.29289L6.29289 2.70711L12.2929 8.70711L13.7071 7.29289ZM6.29289 1.29289L0.292893 7.29289L1.70711 8.70711L7.70711 2.70711L6.29289 1.29289Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18L7.70711 18.7071L7 19.4142L6.29289 18.7071L7 18ZM13.7071 12.7071L7.70711 18.7071L6.29289 17.2929L12.2929 11.2929L13.7071 12.7071ZM6.29289 18.7071L0.292893 12.7071L1.70711 11.2929L7.70711 17.2929L6.29289 18.7071Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeSelect);
export default __webpack_public_path__ + "static/media/sizeSelect.410c5166ccb1c83844e3075c1c746e47.svg";
export { ForwardRef as ReactComponent };